import { render, staticRenderFns } from "./authAdmin.vue?vue&type=template&id=34798ed9&scoped=true&"
import script from "./authAdmin.vue?vue&type=script&lang=js&"
export * from "./authAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34798ed9",
  null
  
)

export default component.exports